import type {z} from 'zod';
import type {
  languageSchema,
  languageTagSchema,
  marketIdSchema,
  previewSchema,
  rotatingVerifySecretSchema,
} from '../validation/query-params.js';

export type MarketId = z.TypeOf<typeof marketIdSchema>;
export type CountryCode = MarketId extends infer M
  ? M extends 'gb'
    ? 'uk'
    : M
  : never;

export type Language = z.TypeOf<typeof languageSchema>;
export type RotatingVerifySecret = z.TypeOf<typeof rotatingVerifySecretSchema>;
export type Preview = z.TypeOf<typeof previewSchema>;
export type LanguageTag = z.TypeOf<typeof languageTagSchema>;

export const MARKETS = [
  `AT`,
  `BE`,
  `CH`,
  `DE`,
  `ES`,
  `FR`,
  `GB`,
  `IT`,
  `NL`,
  `PT`,
  `SE`,
] as const;
